///<reference path='../../node_modules/@angular/material/typings/sidenav/index.d.ts'/>
///<reference path='../../node_modules/@angular/material/typings/datepicker/index.d.ts'/>
import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {RequestOptions, XHRBackend} from '@angular/http';
import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';
import {Router} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {httpAuthFactory, SharedModule} from '@shared/shared.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ProfileModule} from './profile/profile.module';
import {CoreModule} from './core/core.module';

import {InnerMessagesService} from '@shared/service/inner-messages.service';
import {DigitalSignService} from './digital-sign/services/digital-sign.service';
import {LoaderService} from '@shared/service/loader.service';
import {OrdersDeclinedDigitalSignService} from './delivery/services/orders-declined-digital-sign.service';
import {ErrorPageService} from '@shared/service/error-page.service';
import {HostListenerService} from '@shared/service/host-listener.service';
import {OrdersFilterService} from './delivery/services/orders-filter.service';
import {AlertFilterService} from './delivery/services/alert-filter.service';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {OrderAlertsDashboardPollingService} from '@shared/service/order-alerts-dashboard-polling.service';
import {WizardService} from '@shared/service/wizard.service';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {UploadFileService} from '@shared/service/upload-file.service';
import {AppointmentsDashboardPollingService} from './appointments/services/appointments-dashboard-polling.service';
import {LoginRequestService} from '@shared/service/login-request.service';
import {OrderAlertsDetailsPollingService} from './delivery/services/order-alerts-details-polling.service';
import {AlertsService} from './delivery/services/alerts.service';
import {OrderService} from './delivery/services/order.service';
import {TempManageReportsService} from '@cc-commons/services/temp-manage-reports.service';
import {FileManagerPollingService} from '@shared/service/file-manager-polling.service';
import {ContractDeclinedDigitalSignatureService} from '@cc-sp-operator/services/contract-declined-digital-signature.service';
import {ThreadFilterService} from './notification-center/services/nc-thread-filter.service';
import {ThreadService} from './notification-center/services/thread.service';
import {NotificationService} from './notification-center/services/notification.service';
import {PermissionService} from '@shared/service/permission.service';
import {Appointments2Service} from './appointments/services/appointments2.service';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {Appointments2FilterService} from './appointments/services/appointments2-filter.service';
import {ModulesLoadingGuard} from './modules-loading.guard';
import {PermissionGuard} from './permission.guard';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CrossPermissionGuard} from './cross-permission.guard';
import {CalendarService} from './calendar/services/calendar.service';
import {HttpClientModule} from '@angular/common/http';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {ContractsService} from '@cc-commons/services/contracts.service';
import {DossiersService} from './authority/authority-shared/services/dossiers.service';
import {DossiersConsultationService} from './authority/authority-shared/services/dossiers-consultation.service';
import {WorkingsService} from './authority/authority-shared/services/workings.service';
import {OperationsFilterService} from './authority/authority-shared/services/operations-filter.service';
import {WorkingManagerService} from './authority/authority-shared/components/au-operation-working-detail/working-manager/working-manager.service';
import {TyresMovementStatusService} from '@shared/service/tyres-movement-status.service';
import {TyresCommoditiesService} from '@shared/service/tyres-commodities.service';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import { MapsAPILoader, GoogleMapsAPIWrapper, AgmCoreModule } from '@agm/core';
import { CommoditiesUtilityService } from '@shared/service/commodities-utility.service';
import { InjectorService } from '@shared/service/injector.service';
import { DossierWorkingService } from '@authority/authority-shared/services/dossier-working.service';
import { DossierWorkingFilterService } from '@authority/authority-shared/services/dossier-working-filter.service';
import {Redux} from '@shared/utilities/redux';
import { FluxAuthorityService } from './authority/authority-shared/services/flux/flux.authority.service';

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		CoreModule,
		SharedModule,
		ProfileModule,
		AppRoutingModule,
		AgmCoreModule.forRoot({
			clientId: 'gme-adlautomotive',
			language: 'it',
			libraries: ['places', 'geometry']
		})
	],
	providers: [
		AppConfigEnvironmentService,
		{
			provide: APP_INITIALIZER,
			useFactory: (appConfig: AppConfigEnvironmentService) => () => appConfig.initialize(),
			deps: [AppConfigEnvironmentService],
			multi: true,
		},
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		InnerMessagesService,
		MessageManagerService,
		LoaderService,
		DigitalSignService,
		OrdersDeclinedDigitalSignService,
		ErrorPageService,
		HostListenerService,

		OrdersFilterService,
		OrderAlertsDetailsPollingService,
		CalendarService,
		Appointments2FilterService,
		OperationsFilterService,
		AlertFilterService,
		AlertsService,

		ContractsService,
		OrderService,

		LoginRequestService,
		ThreadFilterService,
		{
			provide: HttpAuthService,
			useFactory: httpAuthFactory,
			deps: [XHRBackend, RequestOptions, Location, LoginRequestService, Router, AppConfigEnvironmentService,CommoditiesUtilityService],
		},
		SelectCommoditiesService,
		WizardService,
		OrderAlertsDashboardPollingService,
		AppointmentsDashboardPollingService,
		UploadFileService,
		Redux,
		ContractDeclinedDigitalSignatureService,

		ModulesLoadingGuard,
		PermissionGuard,

		TempManageReportsService,
		FileManagerPollingService,
		ThreadService,
		NotificationService,
		PermissionService,
		CrossPermissionGuard,
		Appointments2Service,
		DossiersService,
		DossiersConsultationService,
		WorkingsService,
		UserV3Service,
		DeviceDetectorService,
		WorkingManagerService,
		TyresMovementStatusService,
		TyresCommoditiesService,
		GoogleMapsAPIWrapper,
		DossierWorkingService,
		DossierWorkingFilterService,
		FluxAuthorityService,
	],
	bootstrap: [AppComponent],
})

export class AppModule {
	
	constructor(private injector: Injector) {
		InjectorService.inject = this.injector;
	}
}
